import React from 'react';
import { useSearchOrdersQuery } from 'API/order/OrderApi';
import { SpinnerTW } from 'tailwindComponents/spinnerTW/SpinnerTW';
import { IPotentialMatch } from './IPotentialMatch';
import { ExpectedOrderTableDisplay } from './ExpectedOrderTableDisplay';
import { ISearchQuery } from './ISearchQuery';
import { createDefaultSearchOrderSpecification } from '../../../ui-toolkit/orders/searchOrder/types/ISearchOrdersSpecification';

export interface IExpectedOrderSearchProps {
  query: ISearchQuery;
  setPotentialMatch: (x: IPotentialMatch) => void;
}

export const ExpectedOrderSearch: React.FC<IExpectedOrderSearchProps> = ({ query, setPotentialMatch }) => {
  const { fileNumber, borrowerName: partyName, propertyAddress: streetAddress } = query;
  const search = { fileNumbers: fileNumber ? [fileNumber] : [], partyName, streetAddress };
  const { data, isLoading } = useSearchOrdersQuery({
    ...createDefaultSearchOrderSpecification(),
    ...search,
  });

  return (
    <>
      {isLoading && <SpinnerTW />}
      {data && <ExpectedOrderTableDisplay data={data} setPotentialMatch={setPotentialMatch} />}
    </>
  );
};
